import { useMemo, useState, useCallback, useEffect } from 'react';
import {
	DxArgumentAxis,
	DxChart,
	DxCommonSeriesSettings,
	DxFormat,
	DxLabel,
	DxLegend,
	DxSeries,
} from '../../../components/common/DxCharts';
import { createUUID } from '../../../utils/createUUID';
import { useSelector } from 'react-redux';
import { AppState } from '../../../context/stores/rootReducers';
import { BaseResponse } from '../../../context/base/BaseResponse';
import { rootApi } from '../../../context/api/rootApi';

interface BaoCaoHocSinhTheoKhoiResponse {
	dm_truong_id: number;
	dm_khoi_id: number;
	ten_truong: string;
	ten_truong_en: string;
	ten_khoi: string;
	ten_khoi_en: string;
	hocsinh_total: number;
}

const BaoCaoHocSinhTheoKhoi = () => {
	const [dataReport, setDataReport] = useState<BaoCaoHocSinhTheoKhoiResponse[]>([]);
	const { dm_coso_id, dm_truong_id, nam_hoc } = useSelector((state: AppState) => state.common);
	const handleReloadData = useCallback(async () => {
		const res: BaseResponse = await rootApi.baoCao.GetBaoCaoHocSinhTheoKhoiAsync(dm_coso_id, dm_truong_id, nam_hoc);
		if (res.isSuccess && res.result) {
			const listCategory = res.result as BaoCaoHocSinhTheoKhoiResponse[];
			setDataReport(listCategory);
		} else {
			setDataReport([]);
		}
	}, [dm_coso_id, dm_truong_id, nam_hoc]);

	useEffect(() => {
		handleReloadData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dm_coso_id, dm_truong_id, nam_hoc]);

	return (
		<>
			<DxChart id={createUUID()} dataSource={dataReport} className='w-100' palette={'Bright'} height={220}>
				{/* <DxTitle text={`Thống kê lớp học theo khối`}>
					<DxFont color='black' size={18} />
				</DxTitle> */}
				<DxCommonSeriesSettings argumentField='ten_khoi' type='bar' hoverMode='allArgumentPoints' selectionMode='allArgumentPoints'>
					<DxLabel visible={true}>
						<DxFormat type='fixedPoint' precision={0} />
					</DxLabel>
				</DxCommonSeriesSettings>
				<DxSeries valueField='hocsinh_total' argumentField='ten_khoi' name='Học sinh' type='bar'></DxSeries>
				<DxArgumentAxis>
					<DxLabel rotationAngle={45} overlappingBehavior='rotate' />
				</DxArgumentAxis>
				<DxLegend orientation='horizontal' verticalAlignment='bottom' horizontalAlignment='center' />
			</DxChart>
		</>
	);
};

export default BaoCaoHocSinhTheoKhoi;
